import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Typography,
  Paper,
  useMediaQuery,
  Card,
  CardContent,
} from "@mui/material";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase";
import { useTheme } from "@mui/material/styles";

function WhatsappHistory() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  // Fetch whatsapp history
  const fetchData = async () => {
    try {
      const q = query(collection(db, "whatsapphistory"), orderBy("timestamp", "desc"), limit(2000));
      const snapshot = await getDocs(q);
      const arr = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setData(arr);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box p={isMobile ? 1.5 : 1}>
      <Typography
        variant={isMobile ? "h6" : "h5"}
        fontWeight="bold"
        mb={2}
        textAlign={isMobile ? "center" : "left"}
      >
        WhatsApp Campaign History
      </Typography>

      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          borderRadius: 2,
          boxShadow: 3,
          overflowX: "auto",
        }}
      >
        {/* ✅ Table View for Desktop / Tablet */}
        {!isMobile ? (
          <>
            <Table>
              <TableHead sx={{ backgroundColor: "#1976d2" }}>
                <TableRow>
                  <TableCell sx={{ color: "#fff" }}>Sr No</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Mobile</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Post Title</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Type</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Sent At</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>{item.mobile}</TableCell>
                      <TableCell>{item.postTitle}</TableCell>
                      <TableCell>{item.type}</TableCell>
                      <TableCell
                        sx={{
                          color: (!item.status || item.status === "sent") ? "green" : "red",
                          fontWeight: 600,
                        }}
                      >
                        {item.status ? item.status : "Sent"}
                      </TableCell>

                      <TableCell>
                        {new Date(item.timestamp).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))}

                {data.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No history found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            <TablePagination
              component="div"
              count={data.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </>
        ) : (
          /* ✅ Card View for Mobile */
          <Box>
            {data.length === 0 ? (
              <Typography textAlign="center" py={3}>
                No history found
              </Typography>
            ) : (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <Card
                    key={item.id}
                    sx={{
                      mb: 2,
                      mx: 1,
                      border: "1px solid #ddd",
                      boxShadow: 1,
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography variant="subtitle2" color="text.secondary">
                        #{page * rowsPerPage + index + 1}
                      </Typography>
                      <Typography variant="body1" fontWeight={600}>
                        📱 {item.mobile}
                      </Typography>
                      <Typography variant="body2" mt={0.5}>
                        <b>Title:</b> {item.postTitle}
                      </Typography>
                      <Typography variant="body2">
                        <b>Type:</b> {item.type}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: item.status === "sent" ? "green" : "red",
                          fontWeight: 600,
                        }}
                      >
                        <b>Status:</b> {item.status}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {new Date(item.timestamp).toLocaleString()}
                      </Typography>
                    </CardContent>
                  </Card>
                ))
            )}

            {/* Pagination for Mobile */}
            <TablePagination
              component="div"
              count={data.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20]}
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
}

export default WhatsappHistory;
